import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1 4.0125L1.8875 3.125L6 7.2375L10.1125 3.125L11 4.0125L6 9.0125L1 4.0125Z" }));
export default SvgChevronDown;
